import gql from 'graphql-tag'

export const GENERATE_CERTIFICATE = gql`
  mutation geraCertificado($curso_id: String!,$user: String) {
    geraCertificado(curso_id: $curso_id,user:$user) {     
      url
    }
  }
`

